<app-view-contract *ngIf="!isCustomerSignState" [contextIdDto]="contextIdDto" [contractId]="contractId"
  [isContractModal]="isContractModal" (customerSignEvent)="customerSignEventChange($event)"
  (contractCreated)="contractCreatedEventChange($event)"></app-view-contract>

<app-customer-view-contract *ngIf="isCustomerSignState" [contextIdDto]="contextIdDto" [contractId]="contractId"
  [isContractModal]="isContractModal"
  (customerSignEvent)="customerSignEventChange($event)"></app-customer-view-contract>